export default __webpack_public_path__ + "static/media/436.b106065e.png";